<template>
  <div class="sm-card-default">
    <div class="sm-card-default__number">
      <div :class="`sm-card-default__number-brand card-brand card-brand-${card.brand ? card.brand.replace(' ', '-').toLowerCase() : 'default'}`"></div>
      <span>xxxx&nbsp;&nbsp;xxxx&nbsp;&nbsp;xxxx&nbsp;&nbsp;{{card.last4}}</span>
      <span>{{card.exp_month}}/{{card.exp_year}}</span>
      <span>***</span>
    </div>
    <div class="sm-card-default__address">
      <h6>Billing address</h6>
      <div class="sm-card-default__address-line flex">
        <div>
          <b>First name</b>
          <span>{{card.name.split(' ')[0]}}</span>
        </div>
        <div>
          <b>Last name</b>
          <span>{{card.name.split(' ')[1]}}</span>
        </div>
      </div>
      <div
        class="sm-card-default__address-line"
        :class="{
          'flex': country
        }"
      >
        <div v-if="country">
          <b>Country</b>
          <span>
            <span :class="`sm-flag sm-icon-flag-${country.name.toLowerCase().replace(new RegExp(' ', 'g'), '_')}`"></span>
            <span>{{country.name}}</span>
          </span>
        </div>
        <div>
          <b>Street</b>
          <span>{{card.billing_address.address}}</span>
        </div>
      </div>
      <div class="sm-card-default__address-line flex">
        <div>
          <b>City</b>
          <span>{{card.billing_address.city}}</span>
        </div>
        <div>
          <b>Zip/Post code</b>
          <span>{{card.billing_address.zip}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'default-card',
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      countryList: 'countryList'
    }),
    country() {
      return this.countryList.find(c => c.code == this.card.billing_address.country);
    }
  }
}
</script>

<style lang="scss">
@use '@/assets/scss/general/mixins.scss' as *;
@use '@/assets/scss/framework/scss-variables.scss' as *;
@use '@/assets/scss/components/credit-card/_card-default.scss';
@use '@/assets/scss/components/_cards-brand.scss';
</style>